import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Native <select> dropdown driven by a master collection.
 * (Previously was input+datalist; converted to strict dropdown list per spec.)
 *
 * Props:
 *  - source: "units" | "categories" | "signatories" | "clients" | "companies" | "sj_codes" | "expense_categories"
 *  - value, onChange, placeholder, className, "data-testid"
 *  - field: which field to use as label/value (defaults to "name")
 */
export default function MasterCombo({ source, value, onChange, placeholder, className = "", field = "name", ...rest }) {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    let mounted = true;
    // Iter v34cj — support source="stocks" untuk sync nama material dari Stok Barang
    const url = source === "clients" ? "/clients"
      : source === "companies" ? "/companies"
      : source === "signatories" ? "/signatories"
      : source === "stocks" ? "/stocks"
      : `/masters/${source}`;
    api.get(url).then((r) => { if (mounted) setOpts(r.data || []); }).catch(() => {});
    return () => { mounted = false; };
  }, [source]);
  // Preserve legacy values (e.g. "delivery" not in master) by injecting them as a hidden option
  const hasCurrent = !value || opts.some((o) => (o[field] || o.name || o.material_name) === value);
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full border border-stone-300 bg-white px-3 py-2 text-sm focus:border-terra-500 focus:ring-1 focus:ring-terra-500 outline-none ${className}`}
      {...rest}
    >
      <option value="">{placeholder || "— Pilih —"}</option>
      {!hasCurrent && <option value={value}>{value} (lama)</option>}
      {opts.map((o) => {
        const v = o[field] || o.name || o.material_name;
        return <option key={o.id || v} value={v}>{v}{o.quantity != null ? ` (stok: ${o.quantity} ${o.unit || ""})` : ""}</option>;
      })}
    </select>
  );
}
